/* モーダルを開いたときに、背景となる body を fixed して、更にスクロール位置を保持する関数です。 */
export default {

    open: function() {
        let scrollPosition;
        const body = document.getElementsByTagName('body')[0];
        const scrollBarWidth = window.innerWidth - document.body.clientWidth;

        body.style.paddingRight = scrollBarWidth + 'px';
        scrollPosition = -window.pageYOffset;
        body.style.position = 'fixed';
        body.style.width = '100%';
        body.style.top = scrollPosition + 'px';
    },
    close: function() {
        let scrollPosition;
        const body = document.getElementsByTagName('body')[0];
        const scrollBarWidth = window.innerWidth - document.body.clientWidth;

        body.style.paddingRight = '';      
        scrollPosition = parseFloat(body.style.top.replace(/[-px]/g, ''));
        body.style.position = '';
        body.style.width = '';
        body.style.top = '';
        window.scrollTo(0, scrollPosition);
    } 

}